export default class Uploader {
    private name: string;

    private $parent: JQuery;
    private $el: JQuery;

    private $remove: JQuery;
    private $title: JQuery;
    private $progress: JQuery;

    private $form: JQuery;
    private $input: JQuery;

    private form: HTMLFormElement;

    private onselect: (file: FormDataEntryValue) => void;
    private ondone: () => void;
    private onfail: (error?: string) => void;
    private onremove: () => void;

    public constructor($parent: JQuery, name: string) {
        this.$parent = $parent;
        this.name = name;

        this.initHtml();
    }

    public getName(): string {
        return this.name;
    }

    public initHtml(): void {
        const name = this.getName();

        const $html = $(`
            <div class="uploader2">
                <div class="uploader2__inner">
                    <button class="uploader2__remove"></button>

                    <div class="uploader2__action">
                        <div class="uploader2__title"></div>
                        <div class="uploader2__progress"></div>
                    </div>
                </div>
            </div>
        `);

        this.$el = $html;
        this.$title = $('.uploader2__title', $html);
        this.$remove = $('.uploader2__remove', $html);
        this.$progress = $('.uploader2__progress', $html);

        this.$form = $(`
            <form method="post" enctype="multipart/form-data" class="uploader2-form">
                <input type="hidden" name="MAX_FILE_SIZE" value="" />
                <input type="hidden" name="name" value="` + name + `">
                <input type="file" name="file" class="uploader2-form__input">
            </form>
        `);

        this.$remove.on('click', (e) => {
            e.preventDefault();

            this.remove();
        });

        $('.uploader2__action', $html).on('click', (e) => {
            e.preventDefault();

            this.browse();
        });

        // --- FORM

        this.form = (<HTMLFormElement> this.$form.get(0));

        this.$input = $('.uploader2-form__input', this.$form);

        this.$input.on('change', (e) => {
            const data = new FormData(this.form);

            this.select(data);
        });

        $html.appendTo(this.$parent);
        this.$form.appendTo('body');
    }

    public setTitle(html: string): void {
        this.$title.html(html);
    }

    public setMaxSize(size?: number): void {
        $('input[name="MAX_FILE_SIZE"]', this.$form).val(size);
    }

    public browse(): void {
        this.$input.click();
    }

    private setProgress(val: number, force?: boolean): void {
        if (val > 1) {
            val = 1;
        }

        if (val < 0) {
            val = 0;
        }

        this.$progress.css('width', (val * 100) + '%');

        if (force) {
            this.$progress[0].offsetHeight;
        }
    }

    private select(data: FormData): void {
        const name = this.getName();
        const file = data.get('name');

        this.$el.removeClass('uploader2--success uploader2--error');

        this.setProgress(0, true);
        this.setTitle('wysyłanie');

        this.$el.addClass('uploader2--uploading');

        if (this.onselect != null) {
            this.onselect(file);
        }

        const url = '/uploader2/' + name + '/send'

        $.ajax({
            url: url,
            type: 'post',
            data: data,
            cache: false,
            contentType: false,
            processData: false,

            xhr: () => {
                const xhr = $.ajaxSettings.xhr();

                xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable) {
                        const p = e.loaded / e.total;

                        this.setProgress(p);
                    }
                };

                return xhr;
            }
        }).done((r) => {
            this.setProgress(1);

            this.$el.removeClass('uploader2--uploading');

            if (r.success) {
                this.$el.addClass('uploader2--success');

                this.setTitle(r.title);

                if (this.ondone != null) {
                    this.ondone();
                }
            } else if (r.error) {
                this.$el.addClass('uploader2--error');

                this.setTitle(r.title);

                if (this.onfail != null) {
                    this.onfail(r.title);
                }
            }
        }).fail(() => {
            this.$el.removeClass('uploader2--uploading');
            this.$el.addClass('uploader2--error');

            this.setTitle('Błąd połączenia');

            if (this.onfail != null) {
                this.onfail();
            }
        });
    }

    public remove(): void {
        const url = '/uploader2/' + this.getName() + '/remove';

        $.post(url).done((r) => {
            if (r.success) {
                this.$el.fadeOut(300, () => {
                    if (this.onremove != null) {
                        this.onremove();
                    }

                    this.$form.remove();
                    this.$el.empty();
                });
            } else {
                this.$el.addClass('uploader2--error');
            }
        });
    }

    public onRemove(callback: () => void): void {
        this.onremove = callback;
    }

    public onSelect(callback: (file: FormDataEntryValue) => void): void {
        this.onselect = callback;
    }

    public onFail(callback: (error?: string) => void): void {
        this.onfail = callback;
    }

    public onDone(callback: () => void): void {
        this.ondone = callback;
    }
}
